<template>
  <div class="min-h-screen flex items-center justify-center bg-gray-100">
    <div class="bg-white p-8 rounded-lg shadow-md w-96">
      <div v-if="loading" class="flex flex-col items-center">
        <div class="animate-spin rounded-full h-12 w-12 border-b-2 border-pdsPrimaryColor-500"></div>
      </div>
      <div v-if="error" class="text-center">
        <p class="mb-4">De patiënt is niet gevonden. Deze moet eerst worden aangemaakt in het Mediq systeem.</p>
        <button
            id="loginButton"
            @click="$router.push('/')"
            class="w-full flex justify-center py-2 px-4 border border-transparent rounded-md shadow-sm text-sm font-medium text-white bg-pdsPrimaryColor hover:bg-pdsPrimaryColor/50 focus:outline-none focus:ring-2 focus:ring-offset-2 focus:ring-pdsPrimaryColor disabled:opacity-50 disabled:cursor-not-allowed"
          >
          Terug naar Dashboard
          </button>
      </div>
    </div>
  </div>
</template>

<script>
import axios from 'axios';
import { isLoggedIn$ } from '@/services';
export default {
  name: 'RedirectPage',
  props: {
    code: {
      type: String,
      required: true
    },
    clientId: {
      type: String,
      required: true
    }
  },
  data() {
    return {
      loading: true,
      error: null
    }
  },
  computed: {
    baseUrl() {
      return window.location.origin;
    }
  },
  async created() {
    try {
      const { data } = await axios.get(`${this.baseUrl}/api/sitecore/v2/Nedap/GetPatientContext`, {
        params: {
          code: this.code,
          client_id: this.clientId
        }
      });

       if (data && typeof data === 'object' && data.PatientId && data.Token) {
          isLoggedIn$.subscribe((value) => {
            var isLoggedIn = value;

          if (isLoggedIn) {
            // Set lastSelectedCustomer to PatientId
            localStorage.setItem('lastSelectedCustomer', data.PatientId);
            // Redirect to patient dashboard if logged in
            window.location.href = `${this.baseUrl}/patientdashboard`;
          } else {
            // If not logged in, redirect to login page with token
            window.location.href = `${this.baseUrl}/inloggen?token=${data.Token}`;
          }
        });
      }
      else {
        this.error = true;
      }

      this.loading = false;
    } catch (err) {
      this.loading = false;
      console.error('Redirect error:', err);
    }
  },
  methods: {
    hasValidAspNetCookie() {
      const cookies = document.cookie.split(';');
      const aspNetCookie = cookies.find(cookie => cookie.trim().indexOf('.AspNet.cookie') !== -1);

      if (!aspNetCookie) return false;
      return true;
    }
  },
}
</script>

